import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { tagsToString } from '@src/main/ui/components/common/Dashboard/common/fields/tags/tagsToString';
import { useSearchContext } from '@src/main/ui/providers/search/SearchContextProvider';
import { FC } from 'react';
import Highlighter from 'react-highlight-words';

interface Props {
  keyTags: string[];
  highlighFields?: HighlighFields[];
}

const defaultProps = {
  highlighFields: undefined,
};

const KeyTagsCardText: FC<Props> = ({ keyTags, highlighFields }) => {
  const { searchInput } = useSearchContext();
  const fieldToHighligh: HighlighFields = 'keyTags';
  return (
    <>
      {highlighFields?.includes(fieldToHighligh) ? (
        <Highlighter searchWords={searchInput.split(' ')} textToHighlight={tagsToString(keyTags)} />
      ) : (
        tagsToString(keyTags)
      )}
    </>
  );
};

KeyTagsCardText.defaultProps = defaultProps;

export default KeyTagsCardText;
